module.exports = __webpack_public_path__ + "assets/7f1959b696c29f394b98f2edb599908b.png";